import React from 'react';
import toastr from 'toastr';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,Dialog,Button,Display,Line,Card,Column,Panel} from 'ktm-ui';

interface IdsBenefit {
    Id:string;
    Policy_Id:string;
    CommissionRatioOurPortion:number;
    CommissionRatioAdvisorPortion:number;
};

export default KTMScreen({name:"planadmin.product.edit-commission-ratio"}, class extends React.Component<{policyBenefit_id:string}> {

    data:{
        dsBenefit:IdsBenefit;
    }

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@dsBenefit";
        await KTMApi.start(screen,{
            "@policyBenefit_id":this.props.policyBenefit_id,
        });
        screen.title = "Edit Commission Ratio";
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Layout>
                {draw(this.header)}
                {draw(this.main_tab)}
                {draw(this.footer)}
            </Layout>
        );
    }

    header({field,draw,action}:RenderEvent){
        return (
            <Dialog.Header label="Edit Commission Ratio"/>
        );
    }

    splitSum():number | null {
        const ours = Number(this.data.dsBenefit.CommissionRatioOurPortion);
        const advisor = Number(this.data.dsBenefit.CommissionRatioAdvisorPortion);
        if (Number.isNaN(ours) || Number.isNaN(advisor)) return null;
        return ours + advisor;
    }

    async autofillAdvisor(){
        const ours = Number(this.data.dsBenefit.CommissionRatioOurPortion);
        if (Number.isFinite(ours) && ours >= 0 && ours <= 100){
            this.data.dsBenefit.CommissionRatioAdvisorPortion = 100 - ours;
        }
    }

    async autofillOurs(){
        const advisor = Number(this.data.dsBenefit.CommissionRatioAdvisorPortion);
        if (Number.isFinite(advisor) && advisor >= 0 && advisor <= 100){
            this.data.dsBenefit.CommissionRatioOurPortion = 100 - advisor;
        }
    }

    footer({field,draw,action}:RenderEvent){
        const sum = this.splitSum();
        const isDisabled =
            this.data.dsBenefit.CommissionRatioOurPortion === null ||
            this.data.dsBenefit.CommissionRatioAdvisorPortion === null ||
            sum !== 100;
        return (
            <Dialog.Footer>
                <Button action={action(this.submit)} label="Save" size="large" style="primary" disable={isDisabled}/>
            </Dialog.Footer>
        );
    }

    details({field,draw,action}:RenderEvent){
        const sum = this.splitSum();
        const showError =
            this.data.dsBenefit.CommissionRatioOurPortion !== null &&
            this.data.dsBenefit.CommissionRatioAdvisorPortion !== null &&
            sum !== 100;
        return (
            <Card>
                <Line>
                    <Display required field={field("CommissionRatioOurPortion")} onValueChanged={action(this.autofillAdvisor)}/>
                    <Display required field={field("CommissionRatioAdvisorPortion")} onValueChanged={action(this.autofillOurs)}/>
                </Line>
                {showError && (
                    <div style={{color:"#b00020",fontSize:13,marginTop:8}}>
                        Our Portion + Advisor Portion must equal 100 (currently {sum}).
                    </div>
                )}
            </Card>
        );
    }

    main_tab({field,draw,action}:RenderEvent){
        return (
            <Panel>
                <Column>
                    {draw(this.details)}
                </Column>
            </Panel>
        );
    }

    async submit({screen}:ActionEvent){
        if (this.splitSum() !== 100){
            toastr.error("Our Portion + Advisor Portion must equal 100.");
            return;
        }
        await KTMApi.action(screen,"submit",{
            "@dsBenefit.CommissionRatioOurPortion":this.data.dsBenefit.CommissionRatioOurPortion,
            "@dsBenefit.CommissionRatioAdvisorPortion":this.data.dsBenefit.CommissionRatioAdvisorPortion,
            "@policyBenefit_id":this.props.policyBenefit_id,
        });
        screen.close({"continue":true});
    }

});
